import {Nav} from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {MenuLinkInterface} from './MenuLinkInterface.ts'

export const MenuExternalLink = ({menu, className}: MenuLinkInterface) => {
    return (
        <Nav.Link
            href={menu.pathName}
            target={'_blank'}
            rel={'noreferrer'}
            className={className}>
            {menu.icon && (
                <FontAwesomeIcon
                    icon={menu.icon}
                    color={'white'}
                    className={'mr-1'}
                />
            )}
            {menu.title}
        </Nav.Link>
    )
}